import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import "../staff-mis.css";
import api from "../api";
import StaffVehiclePage from "./StaffVehiclePage";
import DriverManagementPage from "./DriverManagementPage";
import VehicleDocumentsPage from "./VehicleDocumentsPage";
import VehicleMisPage from "./VehicleMisPage";
import FuelMisPage from "./FuelMisPage";
import ExpenseMisPage from "./ExpenseMisPage";
import ChallanMisPage from "./ChallanMisPage";
import AdHocPaymentsPage from "./AdHocPaymentsPage";
import StaffAttendancePage from "./StaffAttendancePage";
import DailyOperationsMisPage from "./DailyOperationsMisPage";
import VendorManagementPage from "./VendorManagementPage";
import VendorDetailPage from "./VendorDetailPage";
import VendorDriverManagementPage from "./VendorDriverManagementPage";
import VendorAgreementPage from "./VendorAgreementPage";

export function StaffLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState(""),
    [password, setPassword] = useState(""),
    [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    try {
      const response = await api.post("/auth/login", {
        email,
        password,
        portal: "staff",
      });
      if (response.data.user.role !== "staff")
        throw new Error("This is not a Staff account.");
      localStorage.setItem("uride_token", response.data.token);
      localStorage.setItem("uride_user", JSON.stringify(response.data.user));
      nav("/staff/dashboard");
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Unable to sign in.",
      );
    }
  };
  return (
    <main className="staff-auth">
      <form onSubmit={submit}>
        <p>URIDE STAFF PORTAL</p>
        <h1>Staff sign in</h1>
        <span>Use your Staff account credentials to continue.</span>
        {error && <div>{error}</div>}
        <input
          type="text"
          autoComplete="username"
          placeholder="Email address or username"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />
        <button>Sign in</button>
      </form>
    </main>
  );
}

export function StaffRegisterPage() {
  const nav = useNavigate();
  const [form, setForm] = useState({
      fullName: "",
      username: "",
      email: "",
      password: "",
      companyCode: "",
    }),
    [message, setMessage] = useState(""),
    [success, setSuccess] = useState(false);
  const set = (key) => (event) =>
    setForm({ ...form, [key]: event.target.value });
  const submit = async (event) => {
    event.preventDefault();
    try {
      const response = await api.post("/auth/staff/register", form);
      setMessage(response.data.message);
      setSuccess(true);
    } catch (err) {
      setMessage(err.response?.data?.message || "Unable to register.");
    }
  };
  return (
    <main className="staff-auth">
      <form onSubmit={submit}>
        <p>URIDE STAFF PORTAL</p>
        <h1>Create staff account</h1>
        <span>Use your company six-digit code to register.</span>
        {message && !success && <div>{message}</div>}
        <input
          placeholder="Full name"
          value={form.fullName}
          onChange={set("fullName")}
          required
        />
        <input
          placeholder="Username"
          value={form.username}
          onChange={set("username")}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={set("email")}
          required
        />
        <input
          placeholder="Company code (e.g. 000001)"
          value={form.companyCode}
          onChange={set("companyCode")}
          required
        />
        <input
          type="password"
          minLength="8"
          placeholder="Password"
          value={form.password}
          onChange={set("password")}
          required
        />
        <button>Create account</button>
      </form>
      {success && (
        <div className="staff-popup">
          <div>
            <b>OK</b>
            <h2>Registration successful</h2>
            <p>{message}</p>
            <button onClick={() => nav("/staff/login")}>
              Continue to Staff login
            </button>
          </div>
        </div>
      )}
    </main>
  );
}

const staffMenu = [
  ["Attendance", [["Attendance", "attendance"]]],
  [
    "Fleet Management",
    [
      ["Vehicles", "vehicles"],
      ["Drivers", "drivers"],
      ["Vehicle Documents", "documents"],
    ],
  ],
  ["Vendor Management", [["Vendor Management", "vendor-management"], ["Vendor Agreement", "vendor-agreement"]]],
  [
    "MIS Reports",
    [
      ["Daily Operation", "reports/daily-operations"],
      ["Vehicle MIS", "reports/vehicles"],
      ["Fuel MIS", "reports/fuel"],
      ["Expense MIS", "reports/expenses"],
      ["Challan MIS", "reports/challans"],
    ],
  ],
  ["Payments", [["Ad Hoc Vehicle", "payments"]]],
];

export function StaffDashboard() {
  const nav = useNavigate(),
    location = useLocation(),
    user = JSON.parse(localStorage.getItem("uride_user") || "null");
  const section = location.pathname
    .replace("/staff/dashboard/", "")
    .replace("/staff/", "")
    .replace("/staff/dashboard", "");
  if (!user || user.role !== "staff")
    return <Navigate to="/staff/login" replace />;
  if (["management", "reports/payments", "vendors"].includes(section))
    return <Navigate to="/staff/dashboard" replace />;
  const title = section
    ? staffMenu
        .flatMap((item) => item[1])
        .find((item) => item[1] === section)?.[0] || "Staff Workspace"
    : "Dashboard";
  const content =
    section === "vehicles" ? (
      <StaffVehiclePage />
    ) : section === "drivers" ? (
      <DriverManagementPage />
    ) : section === "vendor-management" ? (
      <VendorManagementPage />
    ) : section === "vendor-agreement" ? (
      <VendorAgreementPage />
    ) : section.startsWith("vendor-management/") && section.endsWith("/drivers") ? (
      <VendorDriverManagementPage vendorId={section.split("/")[1]} />
    ) : section.startsWith("vendor-management/") ? (
      <VendorDetailPage vendorId={section.split("/")[1]} />
    ) : section === "documents" ? (
      <VehicleDocumentsPage />
    ) : section === "reports/daily-operations" ? (
      <DailyOperationsMisPage />
    ) : section === "reports/vehicles" ? (
      <VehicleMisPage />
    ) : section === "reports/fuel" ? (
      <FuelMisPage />
    ) : section === "reports/expenses" ? (
      <ExpenseMisPage />
    ) : section === "reports/challans" ? (
      <ChallanMisPage />
    ) : section === "payments" ? (
      <AdHocPaymentsPage />
    ) : section === "attendance" ? (
      <StaffAttendancePage />
    ) : section ? (
      <article>
        <p>STAFF WORKSPACE</p>
        <h2>{title}</h2>
        <span>
          Access your assigned company operational information in this module.
        </span>
      </article>
    ) : (
      <>
        <p>STAFF WORKSPACE</p>
        <h2>Welcome, {user.name}</h2>
        <span>
          Use the sidebar to access fleet management, reports, payments and
          attendance.
        </span>
        <div className="staff-grid">
          {[
            ["Vehicles", "vehicles"],
            ["Drivers", "drivers"],
            ["Attendance", "attendance"],
          ].map(([label, path]) => (
            <Link key={path} to={`/staff/dashboard/${path}`}>
              {label}
              <small>Open module</small>
            </Link>
          ))}
        </div>
      </>
    );
  return (
    <div className="staff-console">
      <a className="skip-link" href="#staff-main">Skip to main content</a>
      <aside>
        <b>
          URIDE STAFF<small>OPERATIONS PORTAL</small>
        </b>
        <Link className={!section ? "active" : ""} aria-current={!section ? "page" : undefined} to="/staff/dashboard">
          Dashboard
        </Link>
        {staffMenu.map(([group, items]) => (
          <div key={group}>
            <p>{group}</p>
            {items.map(([label, path]) => (
              <Link
                className={section === path ? "active" : ""}
                aria-current={section === path ? "page" : undefined}
                key={path}
                to={`/staff/dashboard/${path}`}
              >
                {label}
              </Link>
            ))}
          </div>
        ))}
        <button
          onClick={() => {
            localStorage.clear();
            nav("/staff/login");
          }}
        >
          Sign out
        </button>
      </aside>
      <main id="staff-main" tabIndex="-1">
        <header>
          <div>
            <small>STAFF / {title}</small>
            <h1>{title}</h1>
          </div>
          <span>{user.company?.name || "Company staff"}</span>
        </header>
        <section>{content}</section>
      </main>
    </div>
  );
}
